import { Box, Stack } from '@mui/material';
import IncSwitchField from 'components/forms/fields/inc-switch-field/inc-switch-field.component';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const SetTemporaryHoursFormFooter = () => {
  const { t } = useTranslation();
  const orderType = useWatch({ name: 'orderType' });
  const { setValue } = useFormContext();

  const togglePickup = pickupClosed => {
    if (pickupClosed) {
      setValue(
        'orderType',
        orderType.filter(i => i !== 'PICKUP'),
        { shouldDirty: true },
      );
    }
  };

  const toggleDelivery = deliveryClosed => {
    if (deliveryClosed) {
      setValue(
        'orderType',
        orderType.filter(i => i !== 'DELIVERY'),
        { shouldDirty: true },
      );
    }
  };

  return (
    <Box className="field-container" display="grid" gap={3}>
      <Stack display="flex" direction="row" ml={1}>
        <Box width="50%">
          <IncSwitchField
            name="pickupClosed"
            label={t(
              'forms.setTemporaryHoursForm.footer.fields.pickupClosed.label',
            )}
            onChange={e => {
              togglePickup(e.target.checked);
            }}
            data-testid="SetTemporaryHoursForm.PickupClosed"
          />
        </Box>
        <Box width="50%">
          <IncSwitchField
            name="deliveryClosed"
            label={t(
              'forms.setTemporaryHoursForm.footer.fields.deliveryClosed.label',
            )}
            onChange={e => {
              toggleDelivery(e.target.checked);
            }}
            data-testid="SetTemporaryHoursForm.DeliveryClosed"
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default SetTemporaryHoursFormFooter;
